// PersonalTitleService.js

import { API_URL, getToken, apiKey } from "../components/Constants";

const BASE_URL = `${API_URL}message-logs`;
const BASE_URL_API_Logs = `${API_URL}endPoint-logs`;

const MessageLogsService = {

  getAll: async () => {

    try {
      const token = getToken();
      const response = await fetch(BASE_URL, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'api-key': apiKey
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (response.status === 429) {
          throw new Error('Too many requests. Please wait for one minute');
        }
        const errorMessage = errorData.message || 'An unexpected error occurred.';
        throw new Error(errorMessage);
      }
      const data = await response.json(); 
      return data;
    } catch (error) {
      throw error;
    }
  },

   getAllApiLogs: async () => {

    try {
      const token = getToken();
      const response = await fetch(BASE_URL_API_Logs, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'api-key': apiKey
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (response.status === 429) {
          throw new Error('Too many requests. Please wait for one minute');
        }
        const errorMessage = errorData.message || 'An unexpected error occurred.';
        throw new Error(errorMessage);
      }
      const data = await response.json(); 
      return data;
    } catch (error) {
      throw error;
    }
  },

  

  

  

  delete: async (id) => {
    try {
      const token = getToken();
      const response = await fetch(`${BASE_URL_API_Logs}/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'api-key': apiKey
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.message || 'An unexpected error occurred.';
        throw new Error(errorMessage);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }



  },


};

export default MessageLogsService;